import script from "./LocalTalca.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalTalca.vue?vue&type=script&setup=true&lang=js"

import "./LocalTalca.vue?vue&type=style&index=0&id=5aa16796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa16796"]])

export default __exports__